import React from 'react';
import { Row, Col } from '../../../importCL';
import { wrapTrademarkSuperscript } from '../../../utils/cob-utils';
import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink';

const Pending = ({
    applicationCode,
    printCode,
}) => {
    return (
        <>
            <Row>
                <Col
                    id='applicationCode'
                    className='ConfirmationPageHeroPending__applicationCode'
                    lg={12}
                    md={12}
                >
                    <div className='ConfirmationPageHeroPending__applicationCode'>
                        Application Code:{' '}
                        <strong> {applicationCode} </strong> |{' '}
                        <img
                            loading='lazy'
                            className='ConfirmationPageHero__icon'
                            src={printCode.icon}
                            alt={printCode.alt}
                        />
                        <a href='javascript:window.print()'>
                            {transformHTMLParserLinks(wrapTrademarkSuperscript(printCode.text))}
                        </a>
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default Pending;